import React from "react";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";

const Map = () => {
  const { companyDetailsData } = useCompanyDetailsContext();
  return ( 
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-9cf6a23 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default custom-map-gap"
        data-id="9cf6a23"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-26dd55c"
              data-id="26dd55c"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-7abb2fa elementor-widget elementor-widget-eb-google-map-extended"
                    data-id="7abb2fa"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="eb-google-map-extended.default"
                  >
                    <div className="elementor-widget-container">
                      <iframe
                        title="address"
                        style={{
                          width: "100%",
                          height: "500px",
                          border: 0,
                        }}
                        src={companyDetailsData[0]?.map} 
                        width="600"
                        height="450"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Map;
